import React, { Component } from "react";
import { Tabs } from "antd";
import { connect } from "dva";
import DailyStatisticList from "./List";
import Container from "../../../../../components/Container";
import {
  getBureauDailyList,
  getSchoolDailyList
} from "../../../../../services/activitySign/dataStatistic/dailyStatistic";

const { TabPane } = Tabs;

@connect(({ user }) => ({
  currentUser: user.currentUser
}))
class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nowTabKey: "1"
    };
  }

  handleChangeTab = key => {
    this.setState({
      nowTabKey: key
    });
  };

  // 学校时的tab列表
  renderSchoolTabList = nowTabKey => {
    const listProps = {
      orgType: "school",
      isDetail: false,
      request: getSchoolDailyList
    };
    return (
      <Tabs onChange={this.handleChangeTab} activeKey={nowTabKey} type="card">
        <TabPane key="1" tab="统计明细">
          {nowTabKey === "1" && <DailyStatisticList {...listProps} />}
        </TabPane>
        {/* <TabPane key="2" tab="班级/部门报表">
          {nowTabKey === "2" && "hh"}
        </TabPane>
        <TabPane key="3" tab="本校报表">
          {nowTabKey === "3" && "hh"}
        </TabPane> */}
      </Tabs>
    );
  };

  // 教育局时的tab列表
  renderCountyTabList = nowTabKey => {
    const listProps = {
      orgType: "county",
      isDetail: false,
      request: getBureauDailyList
    };
    return (
      <Tabs onChange={this.handleChangeTab} activeKey={nowTabKey} type="card">
        <TabPane key="1" tab="统计明细">
          {nowTabKey === "1" && <DailyStatisticList {...listProps} />}
        </TabPane>
        {/* <TabPane key="2" tab="统计图表">
          {nowTabKey === "2" && "hh"}
        </TabPane> */}
      </Tabs>
    );
  };

  render() {
    const { nowTabKey } = this.state;
    const { currentUser } = this.props;
    const { orgType } = currentUser;

    const containerProps = {
      breStates: 1,
      isPathParams: true
    };
    return (
      <Container {...containerProps}>
        {orgType === "school"
          ? this.renderSchoolTabList(nowTabKey)
          : this.renderCountyTabList(nowTabKey)}
      </Container>
    );
  }
}

export default index;
